// import React from 'react'
// import { Helmet } from 'react-helmet'
// import LiveTemplateDefault from 'src/components/template/live'
// import { networkLogos } from 'src/constants'
// import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

// export default (props) => {
//   const videoStructuredData = createVideoStructuredData({
//     networkName: 'MS NOW',
//     callsign: 'MSNBC',
//     logoUrl: networkLogos.msnbc.logoUrl,
//     slug: 'msnbc',
//   })

//   return (
//     <>
//       <Helmet>
//         <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
//       </Helmet>
//       <LiveTemplateDefault
//         location={props.location}
//         lang="en"
//         market="us"
//         callsign="MSNBC"
//         title="Watch MS NOW live with Fubo"
//         networkName="MS NOW"
//       />
//     </>
//   )
// }

// TEMPORARY NBC DISPUTE
import React from 'react'
import RedirectTemplate from 'src/components/template/redirect'
export default (props) => <RedirectTemplate location={props.location} destination="/tv" />
